import GoodDataIncompatibleBrowserModal from "./GoodDataIncompatibleBrowserModal";
export { GoodDataIncompatibleBrowserModal };
